module.exports = __webpack_public_path__ + "img/communityadminBanner.7af13b9d.png";